import { actionTypesMaker } from 'redux/lib/utils';

const actionTypes = [
    'GET_USER_INFO_SUCCESS',
    'GET_USER_MODEL_AUTH_SUCCESS',
    'GET_USER_PRIVATE_MODEL_AUTH_SUCCESS',
    'GET_POPULATION_TYPES_SUCCESS',
    'GET_LOGIN_INFO_SUCCESS',
    'GET_COLLECTED_TAG_SUCCESS',
    'COLLECT_TAG_SUCCESS',
    'UNCOLLECT_TAG_SUCCESS',
    'PORTRAIT_TAG_LIST_SUCCESS',
    'PORTRAIT_MODULE_CONDITION_SUCCESS',

    // 暂时-开关状态
    'SWITCH_SUCCESS',
];

export default actionTypesMaker('common', actionTypes);
